// GlobalFilterContext.jsx
import React, { createContext, useContext, useState } from "react";

export const GlobalFilterContext = createContext(); // 👈 add 'export' here

export const GlobalFilterProvider = ({ children }) => {
  const [financialYear, setFinancialYear] = useState("2025-2026");
  const [city, setCity] = useState("Chennai");

  const clearFilters = () => {
    setFinancialYear("2025-2026");
    setCity("Chennai");
  };

  return (
    <GlobalFilterContext.Provider
      value={{ financialYear, setFinancialYear, city, setCity, clearFilters }}
    >
      {children}
    </GlobalFilterContext.Provider>
  );
};

export const useGlobalFilter = () => useContext(GlobalFilterContext);
